/*
 * @Author: your name
 * @Date: 2021-04-21 14:28:28
 * @LastEditTime: 2021-10-27 13:49:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_app\src\plugin\useCommonComponent.js
 */
import Vue from "vue";
import Message from "common/components/Message";
import Confirm from "common/components/Confirm";
import prompt from "common/components/Prompt";
import alert from "common/components/web/alert/alert";

Vue.prototype.$message = Message;
Vue.prototype.$confirm = Confirm;
Vue.prototype.$prompt = prompt;
Vue.prototype.$alert = alert;
